/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
export function addElmStyle(
  el: HTMLElement,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style: Record<string, any>,
  options?: { delay: number },
) {
  if (!el?.style) return;

  const updateStyle = () => {
    Object.keys(style).forEach((key) => {
      el.style[key] = style[key];
    });
  };

  options?.delay ? setTimeout(updateStyle, options.delay) : updateStyle();
}

type DefaultOptions<T> = { duration: number | string } & T;
export function getOptions<T extends object>(options?: number | string | T): T | DefaultOptions<T> {
  if (!options) return {} as T;
  if (typeof options === 'object') return options;

  return {
    duration: options,
  } as DefaultOptions<T>;
}

export const getStyleSheet = (sheetID: string) => {
  let sheet = document.querySelector(`#${sheetID}`) as HTMLStyleElement;
  if (!sheet) {
    sheet = document.createElement('style');
    sheet.id = sheetID;
    document.querySelector('head')?.appendChild(sheet);
  }
  return sheet;
};

export const isRTL = () => document.documentElement.getAttribute('lang-direction') === 'right';

export const isKeyframeExist = (sheetID: string, keyName: string) => {
  const styleSheet = getStyleSheet(sheetID);
  const sheetList = [...(styleSheet.sheet?.cssRules || [])] as Array<CSSKeyframesRule>;

  return sheetList.some((item) => item.name === keyName);
};

export const deleteKeyframeIfExist = (sheetID: string, keyName: string) => {
  const styleSheet = getStyleSheet(sheetID);
  const sheetList = [...(styleSheet?.sheet?.cssRules || [])] as Array<CSSKeyframesRule>;

  for (let i = 0; i < sheetList.length; i += 1) {
    if (sheetList[i]?.name === keyName) {
      styleSheet.sheet?.deleteRule(i);
    }
  }
};

export const hasClass = (el: HTMLElement, className: string) => el.classList.contains(className);

export const removeClass = (el: HTMLElement, classNames: string[]) => el.classList.remove(...classNames);

export const getElFontSize = (el: HTMLElement): number => Number(el.style.fontSize.replace('px', ''));

export const getChild = (el: HTMLElement, index: number) => el.children[index] as HTMLElement;

// 判断是否要rtl
export const useRtl = (options: { noRTL?: boolean }) => {
  const { noRTL = false } = options;
  return {
    isRtl: isRTL() && !noRTL,
  };
};

export function backupElmStyle(el: HTMLElement, style: string[]) {
  if (!el?.style) return;

  const backupStyle = ((el as any)._backStype = (el as any)._backStype || {}) as any;

  style.forEach((key) => {
    backupStyle[key] = style[key];
  });
}

export function restoreElmStyle(el: HTMLElement, style: string[], options?: { delay: number }) {
  if (!el?.style) return;

  const backupStyle = ((el as any)._backStype = (el as any)._backStype || {}) as any;

  const updateStyle = () => {
    style.forEach((key) => {
      el.style[key] = backupStyle[key] || '';
    });
  };

  options?.delay ? setTimeout(updateStyle, options.delay) : updateStyle();
}

export const getElComputedHeight = (el: HTMLElement): number => Number(window.getComputedStyle(el).lineHeight.replace('px', ''));

export const getElFontHeight = (el: HTMLElement): number => getElFontSize(el) || getElComputedHeight(el);
